import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
  
  const firebaseConfig = {
    apiKey: "AIzaSyAlR05upRciFKF8rIJiInBvIDt7xxSDxso",
    authDomain: "muhammedhabeeb-portfolio.firebaseapp.com",
    projectId: "muhammedhabeeb-portfolio",
    storageBucket: "muhammedhabeeb-portfolio.appspot.com",
    messagingSenderId: "735728372518",
    appId: "1:735728372518:web:727d5920d23ccfdc6e4fe7"
  };
  
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

  export {app,db}